import { Box } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import styles from "./styles.module.css";

const LEGACY_ITEM_CLASS = "appSelectOptionListItem";
const DRAG_THRESHOLD = 5;

const AppSelectOptionList = ({
  data = [],
  value = "",
  handleClick,
  wrapperClassName,
  placeholderIcon: PlaceholderIcon,
}) => {
  
  const [failedLogos, setFailedLogos] = useState({});
  const hasScroll = data.length > 4;
  const scrollRef = useRef(null);
  const dragRef = useRef({
    isDragging: false,
    startX: 0,
    scrollLeft: 0,
    moved: false,
  });

  useEffect(() => {
    if (!hasScroll) return undefined;

    const handleMouseMove = (event) => {
      const drag = dragRef.current;
      const container = scrollRef.current;
      if (!drag.isDragging || !container) return;

      const walk = event.pageX - drag.startX;
      if (Math.abs(walk) > DRAG_THRESHOLD) {
        drag.moved = true;
      }
      container.scrollLeft = drag.scrollLeft - walk;
    };

    const handleMouseUp = () => {
      dragRef.current.isDragging = false;
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [hasScroll]);

  const handleMouseDown = (event) => {
    if (!hasScroll || !scrollRef.current) return;

    dragRef.current = {
      isDragging: true,
      startX: event.pageX,
      scrollLeft: scrollRef.current.scrollLeft,
      moved: false,
    };
  };

  const handleWheel = (event) => {
    if (!hasScroll || !scrollRef.current) return;

    if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) {
      event.preventDefault();
      scrollRef.current.scrollLeft += event.deltaY;
    }
  };

  const handleItemClick = (index, item, isDisabled) => {
    if (dragRef.current.moved) {
      dragRef.current.moved = false;
      return;
    }
    if (!isDisabled) handleClick(index, item);
  };

  return (
    <Box
      ref={scrollRef}
      className={`${styles.wrapper} ${hasScroll ? styles.wrapperScrollable : ""} ${wrapperClassName || ""}`}
      onMouseDown={handleMouseDown}
      onWheel={handleWheel}
    >
      {data.map((item, index) => {
        const isActive =
          String(value).toLowerCase() === String(item?.alt ?? "").toLowerCase();
        const isDisabled = item?.active === false;
        const showPlaceholder = !item.image || failedLogos[index];
        return (
          <Box
            tabIndex={0}
            key={index}
            className={[
              styles.item,
              LEGACY_ITEM_CLASS,
              isDisabled ? styles.disabled : "",
              isActive ? styles.itemActive : "",
            ]
              .filter(Boolean)
              .join(" ")}
            onClick={() => handleItemClick(index, item, isDisabled)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey && !isDisabled)
                handleClick(index, item);
            }}
          >
            <div className={styles.logoBox}>
              {!showPlaceholder ? (
                <img
                  className={[styles.logoImage, item.imageClass || ""]
                    .filter(Boolean)
                    .join(" ")}
                  src={item.image}
                  alt={item.alt || "Option"}
                  draggable={false}
                  onError={() =>
                    setFailedLogos((prev) => ({ ...prev, [index]: true }))
                  }
                />
              ) : PlaceholderIcon ? (
                <PlaceholderIcon width={26} height={26} />
              ) : null}
            </div>
            {item.label ? (
              <span className="fontSize12 fontWeight400 newFontColor">
                {item.label}
              </span>
            ) : showPlaceholder && item.alt ? (
              <span className={`fontSize8 fontWeight400 mainColor ${styles.placeholderLabel}`}>
                {item.alt}
              </span>
            ) : null}
          </Box>
        );
      })}
    </Box>
  );
};

export default AppSelectOptionList;
